/**
 * 往 GA4 / Clarity 打自定义事件。失败不影响页面。
 *
 * 不用在 GA4 后台「预先创建」事件。
 * 代码发出去后，GA4「实时」里马上能看到；过几小时会出现在「事件」列表。
 *
 * GA4：gtag('event', 名字, { 参数 }) — 参数能按作品拆表
 * Clarity：clarity('event', 名字) — 只有名字，用来筛热力 / 录屏
 *
 * gtag / 同意若晚于首屏脚本：先入队，就绪后再发，避免刷新时自定义事件丢失。
 */
(() => {
  if (window.pqTrack) return

  const gaPending = []
  const consentPending = []
  let gaTimer = null
  let consentBound = false

  function allowed() {
    if (window.Shopify && window.Shopify.designMode) return false
    const privacy = window.Shopify && window.Shopify.customerPrivacy
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
      try {
        return Boolean(privacy.analyticsProcessingAllowed())
      } catch (error) {
        return false
      }
    }
    return true
  }

  function cleanParams(params) {
    const out = {}
    if (!params || typeof params !== 'object') return out
    Object.keys(params).forEach((key) => {
      const value = params[key]
      if (value == null || value === '') return
      if (typeof value === 'boolean') out[key] = value ? 'true' : 'false'
      else if (typeof value === 'number') out[key] = value
      else out[key] = String(value)
    })
    return out
  }

  function sendClarity(eventName) {
    if (typeof window.clarity === 'function') {
      window.clarity('event', eventName)
    }
  }

  function flushGa() {
    if (!gaReady()) return false
    while (gaPending.length) {
      const item = gaPending.shift()
      dispatchGa(item.eventName, item.payload)
    }
    if (gaTimer) {
      clearInterval(gaTimer)
      gaTimer = null
    }
    return true
  }

  function queueGa(eventName, payload) {
    gaPending.push({ eventName, payload })
    if (gaTimer) return
    let tries = 0
    gaTimer = setInterval(() => {
      tries += 1
      if (flushGa() || tries >= 50) {
        if (gaTimer) {
          clearInterval(gaTimer)
          gaTimer = null
        }
        // 超时仍无 gtag：丢掉队列，避免内存挂起
        if (tries >= 50) gaPending.length = 0
      }
    }, 200)
  }

  function gaReady() {
    return typeof window.gtag === 'function' || window.google_tag_manager != null
  }

  function dispatchGa(eventName, payload) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload)
      return
    }
    // GTM 已在、但未暴露 gtag 时，用 dataLayer 自定义事件（需容器已就绪）
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(Object.assign({ event: eventName }, payload))
  }

  function sendGa(eventName, payload) {
    if (gaReady()) {
      dispatchGa(eventName, payload)
      return
    }
    // localhost / 标签未注入时先入队；有 gtag 的线上域名就绪后再发
    queueGa(eventName, payload)
  }

  function flushConsent() {
    if (!allowed()) return
    while (consentPending.length) {
      const item = consentPending.shift()
      dispatch(item.eventName, item.payload)
    }
  }

  function bindConsent() {
    if (consentBound) return
    consentBound = true
    const onChange = () => flushConsent()
    document.addEventListener('visitorConsentCollected', onChange)
    document.addEventListener('visitorConsentUpdated', onChange)
  }

  function dispatch(eventName, payload) {
    sendGa(eventName, payload)
    sendClarity(eventName)
    return true
  }

  function track(eventName, params) {
    try {
      if (!eventName || typeof eventName !== 'string') return false
      const payload = cleanParams(params)
      if (!allowed()) {
        if (window.Shopify && window.Shopify.designMode) return false
        consentPending.push({ eventName, payload })
        bindConsent()
        return false
      }
      return dispatch(eventName, payload)
    } catch (error) {
      return false
    }
  }

  window.pqTrack = track
})()
